export default __webpack_public_path__ + "static/media/P-048.412b705e.png";